module.exports = __webpack_public_path__ + "img/Z8YgwSSb1FZx2doc3tIH1.c1ca7603.svg";